<template>
  <header>
    <HeaderLogo/>
    <HeaderLinks/>
  </header>
</template>

<script>
  import HeaderLogo from './HeaderLogo';
  import HeaderLinks from './HeaderLinks';

  export default {
    name: 'Header',
    components: { HeaderLinks, HeaderLogo },
  };
</script>

<style lang="less" scoped>
  @import (reference) '../shared.less';

  header {
    padding: @margins[long-v-padding] @margins[long-h-padding] 0;
    display: flex;
    justify-content: space-between;
    flex-shrink: 0;

    @media @vertical {
      padding: @margins-v[long-v-padding] @margins-v[long-h-padding] 0;
      flex-direction: column;
      align-items: center;
    }

    @media @mobile {
      padding: @margins-m[long-v-padding] @margins-m[long-h-padding] 0;
    }

    @media @mobile-vertical {
      padding: @margins-mv[long-v-padding] @margins-mv[long-v-padding] 0;
    }
  }
</style>
